import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { TRAIN_STATES } from "../../constants/home.const";

const TableBotStates = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div className="card djaCenter py-5">
        <p className="h5">No se ha podido cargar la información</p>
      </div>
    );
  }
  const getmsg = (state = "") => {
    switch (state) {
      case TRAIN_STATES.SYNC:
      case TRAIN_STATES.SYNC_FINISHED:
        return { percent: 1, msg: "Sincronizando tus cambios recientes.." };
      case TRAIN_STATES.SERVER_MANAGER:
      case TRAIN_STATES.SERVER_MANAGER_FINISHED:
        return {
          percent: 21,
          msg: "Eliminando modelos obsoletos de tu chatbot..",
        };
      case TRAIN_STATES.TRAIN:
      case TRAIN_STATES.TRAIN_FINISHED:
        return {
          percent: 30,
          msg: "Entrenando un nuevo modelo para tu chatbot..",
        };
      case TRAIN_STATES.ERROR_CATCHER:
      case TRAIN_STATES.ERROR_CATCHER_FINISHED:
        return {
          percent: 58,
          msg: "Buscando posibles errores en el nuevo modelo..",
        };
      case TRAIN_STATES.TRANSFER_MANAGER:
      case TRAIN_STATES.TRANSFER_MANAGER_FINISHED:
        return {
          percent: 70,
          msg: "Transfiriendo tu nuevo chatbot a producción..",
        };
      case TRAIN_STATES.REBOOT:
        return { percent: 75, msg: "Apagando tu chatbot.." };
      case TRAIN_STATES.DRAFT_MODELS:
        return {
          percent: 78,
          msg: "Instalando el nuevo modelo a tu chatbot..",
        };
      case TRAIN_STATES.DRAFT_MODELS_FINISHED:
        return { percent: 99, msg: "Reiniciando tu chatbot.." };
      default:
        return {
          percent: 0,
          msg: "Tu chatbot se encuentra entrenando, tomará unos minutos..",
        };
    }
  };
  return (
    <div className="card" aria-label="table">
      <DataTable
        value={data}
        header={
          <h4>
            <b>Chatbots</b>
          </h4>
        }
        paginator
        rows={50}
        rowsPerPageOptions={[5, 10, 25, 50]}
        filterDisplay="row"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
        filter
        responsiveLayout="scroll"
        aria-label="some"
      >
        <Column
          field={"id"}
          header={"ID"}
          sortable
          filter
          filterMatchMode={["contains"]}
          showFilterMenu={false}
          body={(row) => {
            return row?.id ?? "-";
          }}
          style={{ maxWidth: "8rem" }}
        />
        <Column
          field={"name"}
          header={"Nombre"}
          sortable
          filter
          filterMatchMode={["contains"]}
          showFilterMenu={false}
          body={(row) => {
            return row?.name ? row.name : "-";
          }}
        />
        <Column
          field={"plan"}
          header={"Plan"}
          sortable
          filter
          filterMatchMode={["contains"]}
          showFilterMenu={false}
          body={(row) => {
            return row?.plan ? row.plan : "-";
          }}
        />
        <Column
          field={"version"}
          header={"Versión"}
          sortable
          filter
          filterMatchMode={["contains"]}
          showFilterMenu={false}
          body={(row) => {
            return row?.version ? row.version : "-";
          }}
        />
        <Column
          field={"special_state"}
          header={"Estado"}
          showFilterMenu={false}
          body={(row) => {
            if (!row?.special_state) return "-";
            if (row?.special_state === "chatbot_off")
              return (
                <div>
                  <b>Apagado</b>
                </div>
              );
            if (row?.special_state === "chatbot_on")
              return (
                <div className="text-success">
                  <b>Encendido</b>
                </div>
              );
          }}
        />
        <Column
          field={"state"}
          header={"Entrenamiento"}
          showFilterMenu={false}
          body={(row) => {
            if (!row?.state) return "-";
            if (row.state == TRAIN_STATES.ACTIVE) return <p>Disponible</p>;
            if (row.state == TRAIN_STATES.PENDING) return <p>Pendiente</p>;
            if (row.state == TRAIN_STATES.MAINTENANCE)
              return <p>Deshabilitado</p>;
            const { msg } = getmsg(row.state);
            return row?.state ? msg : "-";
          }}
        />
      </DataTable>
    </div>
  );
};

export default TableBotStates;
